import './styles.css';
import './app/validation.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router/dom';
import { createAppTranslator } from './app/i18n.ts';
import { router } from './app/router.tsx';

const i18n = await createAppTranslator();
const queryClient = new QueryClient({
    defaultOptions: {
        // Errors with a stable code (401, 403, 404, 400) will not succeed on retry.
        queries: { retry: (count, error) => count < 2 && !('status' in error && Number(error.status) >= 400) },
    },
});

const root = document.getElementById('root');
if (root) {
    createRoot(root).render(
        <StrictMode>
            <I18nextProvider i18n={i18n}>
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router} />
                </QueryClientProvider>
            </I18nextProvider>
        </StrictMode>,
    );
}
